import React from 'react';
import styled from 'styled-components';
import { theme, Icon } from '../../../../../ui';

const IconViewed = styled.div`
  min-width: 18px;
  height: 18px;
  position: relative;
  margin-right: 10px;

  &::before {
    width: 6px;
    height: 3px;
    content: '';
    border-bottom: 2px solid ${({ $color }) => $color || theme.colors.PRIMARY};
    border-left: 2px solid ${({ $color }) => $color || theme.colors.PRIMARY};
    position: absolute;
    left: 30%;
    top: 35%;
    transform: rotate(-50deg);
  }
`;

const IconUnseen = styled.div`
  width: 31px;
`;

const IconBlockedSpacer = styled.div`
  width: 12px;
`;

/**
 * PageIcon - Renders the appropriate icon for a page based on its lock status and progress
 */
const PageIcon = ({ page, isLocked, isSectionLocked, isEditMode, darkColor }) => {
  if (isSectionLocked || isLocked) {
    return (
      <>
        <Icon.Lock size='x-small' color={darkColor} />
        <IconBlockedSpacer />
      </>
    );
  }

  if (isEditMode) {
    return <IconUnseen />;
  }

  if (page.progress === 1) {
    return <IconViewed $color={darkColor} />;
  }

  return <IconUnseen />;
};

export default PageIcon;
